import React, { useState } from "react";
import { Modal, Form, Input, Button, Typography } from "antd";
import { KeyOutlined } from "@ant-design/icons";
import { ShowToast, Severty } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";
const { Paragraph } = Typography;

const ResetPassword = ({ resetModal, setResetModal, email, handleCancelReset }) => {

  const { request } = useRequest();
  const [form]      = Form.useForm();
  const [passwordLoading, setPasswordLoading] = useState(false);

  const handleReset = async (values) => {
    const { newPassword } = values;
    setPasswordLoading(true);

    try {
      if (!email) throw new Error("Email not provided for password reset");

      const payload = { email, password: newPassword };

      await request({
        url: apiPath.resetPassword,
        method: "POST",
        data: payload,
        onSuccess: (data) => {
          setPasswordLoading(false);
          ShowToast(data.message, Severty.SUCCESS);
          setResetModal(false);
          form.resetFields();
        },
        onError: (error) => {
          setPasswordLoading(false);
          ShowToast(error?.response?.data?.message || "Something went wrong", Severty.ERROR);
        },
      });
    } catch (err) {
      setPasswordLoading(false);
      ShowToast(err.message, Severty.ERROR);
    }
  };

  return (
    <Modal
      open={resetModal}
      title={null}
      onCancel={handleCancelReset}
      footer={null}
      destroyOnClose
      centered
    >
      <div className="p-4 sm:p-4 w-full max-w-md mx-auto">

        <div className="flex flex-col items-center mb-4">
          <div className="bg-[#94C13E] text-white rounded-full p-4 mb-2">
            <KeyOutlined className="text-2xl" />
          </div>

          <h2 className="text-xl font-semibold text-gray-800">Reset Password</h2>
          <Paragraph className="text-center text-gray-600 mt-2 text-sm">
            Enter a new password for your account associated with <strong>{email}</strong>.
          </Paragraph>
        </div>

        <Form form={form} layout="vertical" onFinish={handleReset}>
          <Form.Item
            label="New Password"
            name="newPassword"
            rules={[
              { required: true, message: "Please enter your new password!" },
              {
                pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{8,}$/,
                message:
                  "Password must have 8+ characters, uppercase, lowercase, number & special character",
              },
            ]}
          >
            <Input.Password
              placeholder="Enter New Password"
              className="rounded-md border-gray-300 focus:border-[#94C13E] focus:ring focus:ring-[#94C13E]/50"
            />
          </Form.Item>

          <Form.Item
            label="Confirm New Password"
            name="confirm_new_password"
            dependencies={["newPassword"]}
            hasFeedback
            rules={[
              { required: true, message: "Please confirm your password!" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Passwords do not match!"));
                },
              }),
            ]}
          >
            <Input.Password
              placeholder="Confirm Password"
              className="rounded-md border-gray-300 focus:border-[#94C13E] focus:ring focus:ring-[#94C13E]/50"
            />
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            loading={passwordLoading}
            className="w-full bg-[#94C13E] hover:bg-[#82b32e] text-white font-medium py-2 rounded-md transition duration-200"
          >
            Update Password
          </Button>
        </Form>
      </div>
    </Modal>
  );
};

export default ResetPassword;
